import { render } from "./NotFound.vue?vue&type=template&id=16f660a6"
const script = {}
script.render = render

export default script